// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-tip[data-v-7050a4f4] {\n  vertical-align: middle;\n  margin-bottom: 4px;\n  margin-left: 2px;\n  color: orange;\n  font-size: 18px;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
